/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Broker_Action_Will_LinkInputs */

const cs_import_broker_action_will_link = /** @type {(inputs: Import_Broker_Action_Will_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojit`)
};

const en_import_broker_action_will_link = /** @type {(inputs: Import_Broker_Action_Will_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

/**
* | output |
* | --- |
* | "Link" |
*
* @param {Import_Broker_Action_Will_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_broker_action_will_link = /** @type {((inputs?: Import_Broker_Action_Will_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Broker_Action_Will_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_broker_action_will_link(inputs)
	return cs_import_broker_action_will_link(inputs)
});